module.exports = __webpack_public_path__ + "static/img/index.270f78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index.png
// module id = zICw
// module chunks = 1